module.exports = __webpack_public_path__ + "static/media/4_hall_interior_front.af4c7701.jpg";